/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-underscore-dangle */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import PropTypes from 'prop-types';
import React, { Component, CSSProperties, PropsWithChildren } from 'react';
import { smoothDnD as container, ContainerOptions, SmoothDnD, dropHandlers } from 'smooth-dnd';

container.dropHandler = dropHandlers.reactDropHandler().handler;
container.wrapChild = false;

type ContainerProps = PropsWithChildren<
    ContainerOptions & {
        render?: (rootRef: React.RefObject<any>) => React.ReactElement;
        style?: CSSProperties;
    }
>;

export class DraggableContainer extends Component<ContainerProps> {
    public static override propTypes = {
        behaviour: PropTypes.oneOf(['move', 'copy', 'drop-zone', 'contain']),
        groupName: PropTypes.string,
        orientation: PropTypes.oneOf(['horizontal', 'vertical']),
        style: PropTypes.object,
        dragHandleSelector: PropTypes.string,
        nonDragAreaSelector: PropTypes.string,
        dragBeginDelay: PropTypes.number,
        animationDuration: PropTypes.number,
        autoScrollEnabled: PropTypes.bool,
        lockAxis: PropTypes.string,
        dragClass: PropTypes.string,
        dropClass: PropTypes.string,
        onDragStart: PropTypes.func,
        onDragEnd: PropTypes.func,
        onDrop: PropTypes.func,
        getChildPayload: PropTypes.func,
        shouldAnimateDrop: PropTypes.func,
        shouldAcceptDrop: PropTypes.func,
        onDragEnter: PropTypes.func,
        onDragLeave: PropTypes.func,
        render: PropTypes.func,
        getGhostParent: PropTypes.func,
        removeOnDropOut: PropTypes.bool,
        dropPlaceholder: PropTypes.oneOfType([
            PropTypes.shape({
                className: PropTypes.string,
                animationDuration: PropTypes.number,
                showOnTop: PropTypes.bool,
            }),
            PropTypes.bool,
        ]),
    };

    public static defaultProps = {
        behaviour: 'move',
        orientation: 'vertical',
    };

    public prevContainer: null;
    public container: SmoothDnD = null!;
    public containerRef: React.RefObject<any> = React.createRef();
    constructor(props: ContainerProps) {
        super(props);
        this.getContainerOptions = this.getContainerOptions.bind(this);
        this.getContainer = this.getContainer.bind(this);
        this.isObjectTypePropsChanged = this.isObjectTypePropsChanged.bind(this);
        this.prevContainer = null;
    }

    public override componentDidMount() {
        this.prevContainer = this.getContainer();
        this.container = container(this.getContainer(), this.getContainerOptions());
    }

    public override componentWillUnmount() {
        this.container.dispose();
        this.container = null!;
    }

    public override componentDidUpdate(prevProps: ContainerProps) {
        if (this.getContainer()) {
            if (this.prevContainer && this.prevContainer !== this.getContainer()) {
                this.container.dispose();
                this.container = container(this.getContainer(), this.getContainerOptions());
                this.prevContainer = this.getContainer();
                return;
            }

            if (this.isObjectTypePropsChanged(prevProps)) {
                this.container.setOptions(this.getContainerOptions());
            }
        }
    }

    public isObjectTypePropsChanged(prevProps: ContainerProps) {
        const { ...containerOptions } = this.props;

        for (const _key in containerOptions) {
            const key = _key as keyof ContainerOptions;
            if (containerOptions.hasOwnProperty(key)) {
                const prop = containerOptions[key];

                if (typeof prop !== 'function' && prop !== prevProps[key]) {
                    return true;
                }
            }
        }

        return false;
    }

    public override render() {
        if (this.props.render) {
            return this.props.render(this.containerRef);
        }
        return (
            <div style={this.props.style} ref={this.containerRef}>
                {this.props.children}
            </div>
        );
    }

    public getContainer() {
        return this.containerRef.current;
    }

    public getContainerOptions(): ContainerOptions {
        return Object.keys(this.props).reduce((result: ContainerOptions, key: string) => {
            const optionName = key as keyof ContainerOptions;
            const prop = this.props[optionName];

            if (typeof prop === 'function') {
                result[optionName] = ((...params: any[]) => (this.props[optionName] as Function)(...params)) as never;
            } else {
                result[optionName] = prop as never;
            }

            return result;
        }, {});
    }
}
